var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "hdtAdminConsoleModal",
            size: "xl",
            "content-class": "menu-bg-blue-transparent-modal hdt-admin-modal",
            title: "Hard Drive Tracking Admin Console",
            "hide-footer": "",
          },
        },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-tabs",
                { attrs: { align: "center", pills: "", card: "" } },
                [
                  _c(
                    "b-tab",
                    {
                      attrs: { id: "hdtgroup", title: "HDT Group", active: "" },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c("vue-bootstrap4-table", {
                                attrs: {
                                  rows: _vm.operators,
                                  columns: _vm.operatorColumns,
                                  config: _vm.operatorConsoleConfig,
                                  classes: _vm.classes,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "name",
                                    fn: function (props) {
                                      return [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(_vm._s(props.row.name)),
                                          ]),
                                        ]),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }